import { DetailsComponent, InputComponent } from "@shopeasy-dashboard-ui/ui-library";
import TextareaComponent from "../Component/FormInput/TextareaComponent";
import { t } from "i18next";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import API from "../API/newIndex";
import Notification from "../Component/Notification";

const AddCustomMetaField = ({
  setmeta_fields,
  meta_fields,
  heading = "blog",
  errors = {},
  setErrors,
  metaFieldData: propMetaFieldData,
  setMetaFieldData: propSetMetaFieldData,
}) => {
  const [internalMetaFieldData, setInternalMetaFieldData] = useState([]);
  const metaFieldData = propMetaFieldData || internalMetaFieldData;
  const setMetaFieldData = propSetMetaFieldData || setInternalMetaFieldData;

  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  const getMetaField = async () => {
    if (propMetaFieldData && propMetaFieldData.length > 0) return;
    try {
      const ApiCall = await API({
        url: `/admin/metafieldgroup/getMetaFieldGroup/${heading}`,
        method: "get",
      });
      if (ApiCall.status === 200 || ApiCall.status === 304) {
        const result = ApiCall?.data;
        setMetaFieldData(result?.data?.custom_fields || []);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  useEffect(() => {
    getMetaField();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [heading]);

  if (!metaFieldData || metaFieldData.length === 0) {
    return null;
  }

  const handleFieldChange = (fieldName, val) => {
    setmeta_fields((prev) => ({ ...prev, [fieldName]: val }));
    if (setErrors) {
      setErrors((prev) => {
        if (!prev?.[fieldName]) return prev;
        const updated = { ...prev };
        delete updated[fieldName];
        return updated;
      });
    }
  };

  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      <DetailsComponent
        title={t("lang_Custom_Field") || "Custom Field"}
        subtitle={t("lang_Add_Custom_Field") || "Add a custom field"}
        open={true}
        showChevron={true}
      >
        <div className="space-y-4">
          {metaFieldData.map((elem, index) => {
            const isRequired = Boolean(
              elem?.is_required === true || elem?.is_required === 1 || elem?.required === true
            );
            const fieldError = errors?.[elem.custom_field_name];
            const fieldValue = meta_fields?.[elem.custom_field_name] ?? "";

            return (
              <div
                key={elem._id || index}
                id={`custom-field-container-${elem.custom_field_name}`}
                className="w-full"
              >
                {elem.custom_field_type === "textarea" ? (
                  <TextareaComponent
                    id={`custom-field-${elem.custom_field_name}`}
                    name={elem.custom_field_name}
                    label={elem.custom_field_name}
                    placeholder={elem.custom_field_name}
                    required={isRequired}
                    value={fieldValue}
                    error={fieldError}
                    onChange={(e) => handleFieldChange(elem.custom_field_name, e.target.value)}
                    rows={3}
                  />
                ) : elem.custom_field_type === "date" || elem.custom_field_type === "date-time" ? (
                  <div className="w-full flex flex-col gap-1 text-left">
                    <label
                      htmlFor={`custom-field-${elem.custom_field_name}`}
                      className="text-[var(--primary-text-color)] font-medium text-[13px] tracking-tight"
                    >
                      {elem.custom_field_name}
                      {isRequired && <span className="text-[var(--color-danger)] ml-0.5">*</span>}
                    </label>
                    <ReactDatePicker
                      id={`custom-field-${elem.custom_field_name}`}
                      name={elem.custom_field_name}
                      className={`w-full px-3 py-1.5 text-sm h-9 border rounded-lg outline-none transition-all duration-150 text-[var(--primary-text-color)] bg-[var(--secondary-bg-color)] border-[var(--border-color)] hover:border-[var(--focus-border-color)] focus:border-[var(--focus-border-color)] ${fieldError ? "!border-[var(--color-danger)]" : ""}`}
                      showTimeSelect={elem.custom_field_type === "date-time"}
                      selected={
                        fieldValue
                          ? moment(fieldValue).isValid()
                            ? moment(fieldValue).toDate()
                            : new Date(fieldValue)
                          : null
                      }
                      onChange={(date) => handleFieldChange(elem.custom_field_name, date)}
                      placeholderText={elem.custom_field_name}
                      dateFormat={elem.custom_field_type === "date-time" ? "dd-MM-yyyy hh:mm aa" : "dd-MM-yyyy"}
                    />
                    {fieldError && (
                      <p className="text-xs text-[var(--color-danger)] font-medium mt-0.5">
                        {fieldError}
                      </p>
                    )}
                  </div>
                ) : (
                  <InputComponent
                    id={`custom-field-${elem.custom_field_name}`}
                    name={elem.custom_field_name}
                    label={elem.custom_field_name}
                    type={elem.custom_field_type || "text"}
                    placeholder={elem.custom_field_name}
                    required={isRequired}
                    value={fieldValue}
                    error={fieldError}
                    onChange={(e) => handleFieldChange(elem.custom_field_name, e.target.value)}
                  />
                )}
              </div>
            );
          })}
        </div>
      </DetailsComponent>
    </>
  );
};

export default AddCustomMetaField;
